import { supabase, isSupabaseConfigured } from './supabase'
import { logger } from './logger'

const log = logger('Stripe')

/**
 * Redirect to Stripe Checkout for subscription
 */
export async function redirectToCheckout(userId: string, priceId: string): Promise<void> {
  if (!isSupabaseConfigured) {
    log.warn('Supabase not configured')
    return
  }

  const { data, error } = await supabase.functions.invoke('create-checkout', {
    body: { userId, priceId, appUrl: window.location.origin },
  })

  if (error) {
    log.error('Failed to create checkout session:', error)
    throw new Error('Failed to create checkout session')
  }

  if (data?.url) {
    window.location.href = data.url
  } else {
    throw new Error('No checkout URL returned')
  }
}

/**
 * Cancel subscription (at end of billing period)
 */
export async function cancelSubscription(): Promise<void> {
  if (!isSupabaseConfigured) {
    log.warn('Supabase not configured')
    return
  }

  const CANCEL_TIMEOUT_MS = 15_000

  const { data, error } = await Promise.race([
    supabase.functions.invoke('cancel-subscription'),
    new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('Cancel subscription timed out. Please try again.')), CANCEL_TIMEOUT_MS)
    ),
  ])

  if (error) {
    log.error('Failed to cancel subscription:', error)
    throw new Error('Failed to cancel subscription')
  }

  if (data?.error) {
    throw new Error(data.error)
  }
}
